import { render, staticRenderFns } from "./reasonOptions.vue?vue&type=template&id=ff743288&"
import script from "./reasonOptions.vue?vue&type=script&lang=js&"
export * from "./reasonOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff743288')) {
      api.createRecord('ff743288', component.options)
    } else {
      api.reload('ff743288', component.options)
    }
    module.hot.accept("./reasonOptions.vue?vue&type=template&id=ff743288&", function () {
      api.rerender('ff743288', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/serverList/reasonOptions.vue"
export default component.exports